/**
 * Interpolates a value between a starting and ending range based on a progress factor.
 * @param start - The starting value of the range.
 * @param end - The ending value of the range.
 * @param progress - A value between 0 and 1 representing the progress through the range.
 * @returns The interpolated value.
 */
export const interpolate = (
  start: number,
  end: number,
  progress: number,
): number => {
  // Restrict progress value between 0 and 1.
  const restrictedProgress = Math.max(0, Math.min(1, progress));

  return start + (end - start) * restrictedProgress;
};
